const VARIANTS = {
  primary:
    'bg-brand text-on-brand border border-transparent hover:bg-brand-lift active:bg-brand-deep ' +
    'disabled:bg-surface-2 disabled:text-ink-3 disabled:border-hairline disabled:cursor-not-allowed',
  ghost:
    'bg-transparent text-ink border border-edge hover:border-brand ' +
    'disabled:text-ink-3 disabled:border-hairline disabled:cursor-not-allowed',
  // Quiet by default and only alert on contact, because cancelling is not the
  // thing we are inviting.
  danger:
    'bg-transparent text-alert border border-edge hover:border-alert ' +
    'disabled:text-ink-3 disabled:border-hairline disabled:cursor-not-allowed',
  destructive:
    'bg-alert text-white border border-transparent hover:brightness-110 ' +
    'disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:brightness-100',
}

const SIZES = {
  md: 'min-h-[48px] px-5 rounded-btn text-body',
  // 44px: still a full touch target, used where the action is available rather
  // than invited — cancelling, and the two halves of its confirmation.
  compact: 'min-h-[44px] px-4 rounded-btn text-body',
  sm: 'min-h-[36px] px-3 rounded-chip text-body-s',
}

export default function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...props
}) {
  return (
    <button
      type="button"
      className={`font-body font-semibold inline-flex items-center justify-center gap-2
                  transition-colors duration-quick ease-out
                  ${SIZES[size]} ${VARIANTS[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}
